import {ApiCollection} from "./api.collection";
import {SentencingAction} from "../models/sentencing-action.model";


export const SentencingActions = ApiCollection.extend({
    model: SentencingAction,
    url: 'api/sentencing_actions',
});
